import { flatMultiplier, outcomeMultiplier } from '../config.js';
import { firstHalfBtts, firstHalfGoals, halftimeOutcome, hasHalftime, secondHalfGoals, topHalf, YES_NO } from './helpers.js';
const flat = flatMultiplier;
const opt = outcomeMultiplier;
/** Legs graded from the half-time score (coverage: always present where score is). */
export const HALFTIME_MARKETS = [
    {
        id: 'firstHalfGoal',
        label: 'Goal in the first half?',
        shortLabel: '1H goal',
        kind: 'binary',
        requires: 'halftime',
        options: [
            { value: 'YES', label: 'Yes', multiplier: opt('firstHalfGoal', 'YES') },
            { value: 'NO', label: 'No', multiplier: opt('firstHalfGoal', 'NO') }
        ],
        gradeable: hasHalftime,
        isHit: (s, r) => s === (firstHalfGoals(r) > 0 ? 'YES' : 'NO'),
        winningLabel: (r) => (!hasHalftime(r) ? null : firstHalfGoals(r) > 0 ? 'Yes' : 'No')
    },
    {
        id: 'goalBothHalves',
        label: 'A goal in both halves?',
        shortLabel: 'Both halves',
        kind: 'binary',
        multiplier: flat('goalBothHalves'),
        requires: 'halftime',
        options: YES_NO,
        gradeable: hasHalftime,
        isHit: (s, r) => s === (firstHalfGoals(r) > 0 && secondHalfGoals(r) > 0 ? 'YES' : 'NO'),
        winningLabel: (r) => !hasHalftime(r) ? null : firstHalfGoals(r) > 0 && secondHalfGoals(r) > 0 ? 'Yes' : 'No'
    },
    {
        id: 'htResult',
        label: 'Half-time result',
        shortLabel: 'HT result',
        kind: 'ternary',
        requires: 'halftime',
        options: [
            { value: 'HOME', label: 'Home', multiplier: opt('htResult', 'HOME') },
            { value: 'DRAW', label: 'Draw', multiplier: opt('htResult', 'DRAW') },
            { value: 'AWAY', label: 'Away', multiplier: opt('htResult', 'AWAY') }
        ],
        teamRelative: true,
        gradeable: hasHalftime,
        isHit: (s, r) => s === halftimeOutcome(r),
        winningLabel: (r) => !hasHalftime(r) ? null : halftimeOutcome(r) === 'DRAW' ? 'Draw' : halftimeOutcome(r) === 'HOME' ? 'Home' : 'Away'
    },
    {
        id: 'firstHalfBtts',
        label: 'Both teams to score in the first half?',
        shortLabel: '1H BTTS',
        kind: 'binary',
        requires: 'halftime',
        options: [
            { value: 'YES', label: 'Yes', multiplier: opt('firstHalfBtts', 'YES') },
            { value: 'NO', label: 'No', multiplier: opt('firstHalfBtts', 'NO') }
        ],
        gradeable: hasHalftime,
        isHit: (s, r) => s === (firstHalfBtts(r) ? 'YES' : 'NO'),
        winningLabel: (r) => (!hasHalftime(r) ? null : firstHalfBtts(r) ? 'Yes' : 'No')
    },
    {
        id: 'highestScoringHalf',
        label: 'Highest-scoring half',
        shortLabel: 'Top half',
        kind: 'ternary',
        requires: 'halftime',
        options: [
            { value: 'FIRST', label: '1st half', multiplier: opt('highestScoringHalf', 'FIRST') },
            { value: 'SECOND', label: '2nd half', multiplier: opt('highestScoringHalf', 'SECOND') },
            { value: 'EQUAL', label: 'Equal', multiplier: opt('highestScoringHalf', 'EQUAL') }
        ],
        gradeable: hasHalftime,
        isHit: (s, r) => s === topHalf(r),
        winningLabel: (r) => (!hasHalftime(r) ? null : ({ FIRST: '1st half', SECOND: '2nd half', EQUAL: 'Equal' })[topHalf(r)])
    }
];
//# sourceMappingURL=catalogHalftime.js.map